export default __webpack_public_path__ + "static/media/nattu-adnan-unsplash.c866d607.jpg";